





































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import numeral from 'numeral';
import { writeTransportCostsWorkbookBuffer } from './buildTransportCostsWorkbook';

import TransportCostsForm from './TransportCostsForm/TransportCostsForm.vue'
import TransportCostsManyForm from './TransportCostsManyForm/TransportCostsManyForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
    ...mapGetters(STORE_KEY, [
      'totalData'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions'
    ])
  },
  components: {
    TitleBar
  }
})
export default class TransportCostsReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'Транспортные расходы'
    ]
  }
  numeral = numeral

  localFilter = {
    dZoneGroups: null,
    targetDates: [new Date(), new Date()],
    product_id: null,
    product_container_id: null,
    by: 'delivery'
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'client_name', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  get selectedView() {
    return this.$route.params.by || 'delivery'
  }
  
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.$route.query && this.$route.query.targetDates) {
      // @ts-ignore
      this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];
      // @ts-ignore
      this.localFilter.product_id = (this.$route.query && this.$route.query.product_id) ? this.$route.query.product_id : null;
      // @ts-ignore
      this.localFilter.product_container_id = (this.$route.query && this.$route.query.product_container_id) ? this.$route.query.product_container_id : null;
      // @ts-ignore
      this.localFilter.by = (this.$route.query && this.$route.query.by) ? this.$route.query.by : 'delivery';
  
      this.handleParamsChange();
    }
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  openTransportCostsForm() {
    this.$buefy.modal.open({
      component: TransportCostsManyForm,
      props: {
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }


  changeTrancportCost(row: any) {
    console.log(row)
    this.$buefy.modal.open({
      component: TransportCostsForm,
      props: {
        deliveryInstances: row.di_ids.map((item: any) => {
          return 'd:delivery_instances:' + item.delivery_instance_id
        }),
        delivery_zone_group_id: row.zone_id,
        delivery_date: row.delivery_date,
        by_mode: this.localFilter.by,
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  tableToExcel() {
    const csvContent: any[] = this.$store.getters[`${STORE_KEY}/exportData`] || [];
    if (process.env.NODE_ENV === 'development') {
      console.debug('[TransportCostsReport.tableToExcel] START', {
        rows: csvContent.length,
        cols: csvContent[0] ? csvContent[0].length : 0,
      });
    }
    if (!csvContent.length) {
      console.warn('[TransportCostsReport.tableToExcel] empty exportData — skip download');
      return;
    }

    writeTransportCostsWorkbookBuffer(csvContent)
      .then((xls64: any) => {
        const a = document.createElement('a');
        const data = new Blob([xls64], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(data);
        a.href = url;
        a.download = 'export.xlsx';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
        if (process.env.NODE_ENV === 'development') {
          console.debug('[TransportCostsReport.tableToExcel] DONE');
        }
      })
      .catch((error) => {
        const e = error as any;
        console.error('[TransportCostsReport.tableToExcel] ERROR', {
          message: e && e.message,
          stack: e && e.stack,
        });
      });
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
